module.exports = __webpack_public_path__ + "src/img/oldbrick.png?bdf519be2cce301cb33661835f7b981d";


//////////////////
// WEBPACK FOOTER
// ./src/img/oldbrick.png
// module id = 195
// module chunks = 0